import React from 'react';
import { H1, Subtitle, Dash } from './styles';

export default ({
	children: [
		title,
		subtitle,
		...children
	]
}) => (
	<H1>
		{title}
		<Subtitle>
			<Dash>
				&nbsp;-&nbsp;
			</Dash>
			{subtitle || ''}
		</Subtitle>
		{children}
	</H1>
)
